module.exports = __webpack_public_path__ + "static/terveystalo-7eed206088263a738595b9f76de632d5.svg";